// measure-ressource-planning-type.ts
// Type de ressource planifiée pour une mesure de prévention.
// Mappe vers l'enum API integer : Material=0, Equipment=1

export type MeasureRessourcePlanningType = "Material" | "Equipment";

export const RESSOURCE_TYPE_TO_INT: Record<MeasureRessourcePlanningType, 0 | 1> = {
  Material: 0,
  Equipment: 1,
};

export const INT_TO_RESSOURCE_TYPE: Record<number, MeasureRessourcePlanningType> = {
  0: "Material",
  1: "Equipment",
};
